/* src/app/sections/typography-section/typography-section.component.css */
/*# sourceMappingURL=typography-section.component.css.map */
